import { useEffect } from "react"
import { useStore } from "../../../../app/stores/store"

export const useFetch = () => {
    const { getEquipmentRam } = useStore().homeTableEquipmentStore
    const { selectedStation } = useStore().commonStore
    
    useEffect(() => {
        if (selectedStation) {
            getEquipmentRam(selectedStation.id)
        }
    }, [getEquipmentRam, selectedStation])
}